export default "/images/641dc8a43e8a355a3cae6ec7483a058c.avif";